import $ from 'jquery';
import JQueryView, { on } from '../../../../../../common/views/jqueryView';

export default class ProcedureCheckView extends JQueryView {
  constructor() {
    super('.my.investors.specific_applications.users.renewal_application');

    this.render();
  }

  @on({ event: 'change', selector: '#consent' })
  onChangeConsent() {
    this.render();
  }

  render() {
    if ($('#consent').prop('checked')) {
      $('#btn-submit').prop('disabled', false);
    } else {
      $('#btn-submit').prop('disabled', true);
    }
  }
}
